import { Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import type { DraftDestination } from './transferDraft'

import { TransferDestinationChip } from './TransferDestinationChip'

const COLLAPSED_CHIP_LIMIT = 3

function Subheader({
  isArchived,
  onAdd,
}: {
  isArchived: boolean
  onAdd: () => void
}) {
  return (
    <div className="flex h-10 items-center justify-between">
      <span className="text-sm font-medium text-primary-high-contrast">
        Destinations
      </span>
      {!isArchived && (
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label="Add destination"
          onClick={onAdd}>
          <Plus className="size-4.5" />
        </Button>
      )}
    </div>
  )
}

type DestinationListProps = {
  destinations: DraftDestination[]
  isExpanded: boolean
  isArchived: boolean
  onAdd: () => void
  onEdit: (id: string) => void
}

export function TransferDestinationList({
  destinations,
  isExpanded,
  isArchived,
  onAdd,
  onEdit,
}: DestinationListProps) {
  return (
    <>
      {isExpanded && <Subheader isArchived={isArchived} onAdd={onAdd} />}
      {destinations.length === 0 ? (
        <p className="text-sm font-medium text-neutral-solid">
          No destinations added
        </p>
      ) : isExpanded ? (
        <div className="flex flex-col">
          {destinations.map((dest, i) => (
            <TransferDestinationChip
              key={dest.id}
              destination={dest}
              variant="expanded"
              isFirst={i === 0}
              isLast={i === destinations.length - 1}
              disabled={isArchived}
              onEdit={() => onEdit(dest.id)}
            />
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {destinations.slice(0, COLLAPSED_CHIP_LIMIT).map((dest) => (
            <TransferDestinationChip
              key={dest.id}
              destination={dest}
              variant="collapsed"
            />
          ))}
          {destinations.length > COLLAPSED_CHIP_LIMIT && (
            <p className="text-sm text-text-body">
              +{destinations.length - COLLAPSED_CHIP_LIMIT} Destinations
            </p>
          )}
        </div>
      )}
    </>
  )
}
